import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from '@components/layout/Layout';
import { Home } from '@pages/Home';
import { UnitPage } from '@pages/units/UnitPage';
import { TrabajosPracticos } from '@pages/resources/TrabajosPracticos';
import { ProyectosFinales } from '@pages/resources/ProyectosFinales';
import { HerramientasOnline } from '@pages/resources/HerramientasOnline';
import { HeredabilidadCalculator } from '@components/calculators/HeredabilidadCalculator';
import { SeleccionSimulator } from '@components/calculators/SeleccionSimulator';
import { EndocriaCalculator } from '@components/calculators/EndocriaCalculator';
import { HeterosisEstimator } from '@components/calculators/HeterosisEstimator';
import { ExperimentDesigner } from '@components/calculators/ExperimentDesigner';
import { UnitConverter } from '@components/calculators/UnitConverter';
import { ScrollToTop } from '@components/common/ScrollToTop';

export const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/unidad/:unitNumber" element={<UnitPage />} />
          <Route path="/trabajos-practicos" element={<TrabajosPracticos />} />
          <Route path="/proyectos-finales" element={<ProyectosFinales />} />
          <Route path="/herramientas-online" element={<HerramientasOnline />} />
          <Route path="/calculadora-heredabilidad" element={<HeredabilidadCalculator />} />
          <Route path="/simulador-seleccion" element={<SeleccionSimulator />} />
          <Route path="/calculadora-endocria" element={<EndocriaCalculator />} />
          <Route path="/estimador-heterosis" element={<HeterosisEstimator />} />
          <Route path="/disenador-experimentos" element={<ExperimentDesigner />} />
          <Route path="/convertidor-unidades" element={<UnitConverter />} />
        </Routes>
      </Layout>
    </Router>
  );
};
